import { Fragment, type JSX } from 'react';

export const multiplyChildren = (m: number, elements: JSX.Element[]) => {
  return [...Array(Number.isFinite(m) && m >= 0 ? m : 0)].map((_, i) => (
    <Fragment key={i}>{elements}</Fragment>
  ));
};

export const getMultiplier = (itemSetSize: number, containerSize: number) => {
  return itemSetSize < containerSize ? Math.ceil(containerSize / itemSetSize) : 1;
};

export const getDuration = (itemSetSize: number, multiplier: number, speed: number) => {
  return (itemSetSize * multiplier) / speed;
};
